$(document).ready(function() {
	
	var arrivalLocation = $("input[name=arrivalCityNameOfLastLeg]").val();
	var arrivalDate = $("input[name=arrivalTimeOfLastLeg]").val();
	var airportCode = $("input[name=arrivalAirportCode]").val();

	getSuggestedHotels(arrivalLocation, arrivalDate, airportCode);
});


function getSuggestedHotels(arrivalLocation, arrivalDate, airportCode){
	$.ajax({
		url : "/suggestedHotels",
		dataType : "html",
		data :{
			arrivalCityNameOfLastLeg : arrivalLocation,
			arrivalTimeOfLastLeg : arrivalDate,
			airportCode: airportCode
		},
		success : function(data) {
			if(data){
				$("#suggestedHotelDiv").html(data);
			} else {
				$("#suggestedHotelDiv").html('');
			}
		},
		error : function(err){
			$("#suggestedHotelDiv").html('');
		}
	});
}